
import { ref, computed } from 'vue';

export function capitalize( string ) {

  return string.charAt( 0 ).toUpperCase() + string.slice( 1 );

}

export function formatTime( seconds ) {

  return new Date( 1000 * seconds ).toISOString().slice( 14, 19 );

}

export function formatTimelineDate( item ) {

  const { era, month, day, year } = item;

  return era ? era : [ month, day ? `${ day },` : '', year ].join( ' ' ).trim();

}

export function prettifyAudioName( name ) {

  return name
  
    .replace( /^\d+-/, '' )
    
    .split( /-/ )

    .reduce( ( name, word ) => `${ name } ${ capitalize( word ) }`, '' );

}

export function parseImageName( path ) {

  const name = path.split( /\// ).pop().split( /\./ )[ 0 ];
    
  return name ? name.replace( /%20/g, ' ' ) : '';

}

export function cycleRef( limit = Infinity, initial = 0 ) {

  const internal = ref( initial );

  return computed( {

    get: () => internal.value,

    set: value => {

      const result = value % limit;

      internal.value = result < 0 ? limit + result : result;

    }

  } );

}
